import type { ContactListResponse, ListContactsOptions } from "@shopify-harness/sdk";
import { queryOptions } from "@tanstack/react-query";

const CONTACTS_PREVIEW_LIMIT = 100;

export interface ContactsApi {
  list: (options?: ListContactsOptions) => Promise<ContactListResponse>;
}

export const contactQueryKeys = {
  all: ["contacts"] as const,
  list: (limit: number) => [...contactQueryKeys.all, "list", { limit }] as const
};

export function contactsQueryOptions(api: ContactsApi) {
  return queryOptions({
    queryKey: contactQueryKeys.list(CONTACTS_PREVIEW_LIMIT),
    queryFn: ({ signal }) => api.list({ limit: CONTACTS_PREVIEW_LIMIT, signal }),
    staleTime: 30_000
  });
}
